module.exports = __webpack_public_path__ + "static/grouppic-19b2097856dbb60db24d072dd6365ac8.jpg";